import { useContext } from 'react';
import { BasicBenefitsChartsDataContext } from '../contexts/BasicBenefitsChartContext';

export const useBasicBenefitsChartsDataContext = () => {
    return useContext(BasicBenefitsChartsDataContext);
};
